module.exports = __webpack_public_path__ + "media/icons/filter-search@3x-f129bb67.svg";